<rask-page
    pageTitle="{{ 'JUSTERA_LEVERANSPLAN_BALANSERA' | translate }}"
    noPadding>
    <rask-tabs parameterName="tab" class="mb-0 h-100" aid="tabs" [size]="5" layout="header" [isQueryParam]="false">
        <rask-tab label="{{ 'JUSTERA_LEVERANSPLAN_TAB_KUNDORDER' | translate }}" routeId="kundorder"
            [canDeactivate]="kundorder.canDeactivate">
            <rask-jlp-kundorder [canEdit]="canEdit$ | async" #kundorder></rask-jlp-kundorder>
        </rask-tab>
        <rask-tab label="{{ 'JUSTERA_LEVERANSPLAN_TAB_LEVERANTORSORDER' | translate }}" routeId="leverantorsorder"
            [canDeactivate]="leverantorsorder.canDeactivate">
            <rask-jlp-leverantorsorder [canEdit]="canEdit$ | async" #leverantorsorder></rask-jlp-leverantorsorder>
        </rask-tab>
        <rask-tab label="{{ 'JUSTERA_LEVERANSPLAN_TAB_PRODUKTIONSOMRADE' | translate }}" routeId="produktionsomraden"
            [canDeactivate]="produktionsomraden.canDeactivate">
            <rask-jlp-produktionsomraden [canEdit]="canEdit$ | async" #produktionsomraden></rask-jlp-produktionsomraden>
        </rask-tab>
    </rask-tabs>
</rask-page>
